import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Search,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  CheckCircle,
} from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { fetchAutomaticResponseHistory } from "./DataServices/AutomaticResponsesDataServices";
import { fetchPublicTenantLeads } from "./DataServices/PublicTenantLeadsDataService";
import {
  IPublicTenantLead,
  IAutomaticResponseHistory,
  MemberGuarantorInfo,
  AutoResponseDetailsinfo,
  IConfirmedAppfolioAssignment,
} from "./Models";
import MemberMatcher from "./AppfolioDashboard";
import AppfolioUnsignedList from "./AppfolioUnsignedList";
import PublicTenantLeads from "./PublicTenantLeads";
import BankDetailsPage from "./BankDetailsPage";

import {
  fetchPaymentAndBidInfo,
  GetMemberAndGuarntor,
  savePaymentAndBidInfo,
  GetAllMemberAndGuarantor,
  fetchConfirmedAppfolioAssignments,
} from "./DataServices/ProspectiveTenantDataService";
import TenantMapping from "./TanentMapping";
import MemberStatusFlow from "./MemberStatusFlow";
import TenantGroupDetailsPanel from "./TenantGroupDetailsPanel";
import GroupDetailsDrawer from "./GroupDetailsDrawer";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { DateTime } from "luxon";
import ComposeEmail from "./ComposeEmail";
import Loading from "./Loading";
import { useLocation, useNavigate } from "react-router-dom";

interface ExpandedRows {
  [key: string]: boolean;
}

interface ReminderStatus {
  [key: string]: boolean;
}

interface MappingInfo {
  [key: string]: {
    totalMembers: number;
    mappingTotalMembers: number;
    mappedMembers: number;
  };
}

export const MembersDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const initialTab = params.get("tab");

  const [expandedRows, setExpandedRows] = useState<ExpandedRows>({});
  const [reminderStatus, setReminderStatus] = useState<ReminderStatus>({});
  const [memberGuarantorInfos, setMemberGuarantorInfos] = useState<{
    [key: string]: AutoResponseDetailsinfo;
  }>({});
  const [mappingInfo, setMappingInfo] = useState<MappingInfo>({});
  const [automaticResponseHistoryList, setAutomaticResponseHistoryList] =
    useState<IAutomaticResponseHistory[]>([]);
  const [filteredMembers, setFilteredMembers] = useState<
    IAutomaticResponseHistory[]
  >([]);
  const [appfolioMembers, setAppfolioMembers] = useState<IPublicTenantLead[]>(
    [],
  );
  const [publicLeads, setPublicLeads] = useState<any[]>([]);
  const [confirmedAppfolioAssignments, setConfirmedAppfolioAssignments] =
    useState<IConfirmedAppfolioAssignment[]>([]);

  const [nameFilter, setNameFilter] = useState("");
  const [apartmentFilterOptions, setApartmentFilterOptions] = useState<
    string[]
  >([]);
  const [groupSizeFilterOptions, setGroupSizeFilterOptions] = useState<
    string[]
  >([]);
  const [showingStatusFilter, setShowingStatusFilter] = useState<string[]>([]);
  const [externalStatusFilter, setExternalStatusFilter] = useState<string[]>(
    [],
  );
  const [appfolioStatusFilter, setAppfolioStatusFilter] = useState<string[]>(
    [],
  );
  const [showShowingStatusDropdown, setShowShowingStatusDropdown] =
    useState(false);
  const [showExternalStatusDropdown, setShowExternalStatusDropdown] =
    useState(false);
  const [showAppfolioStatusDropdown, setShowAppfolioStatusDropdown] =
    useState(false);
  const [editingGroup, setEditingGroup] = useState<{
    [key: string]: { tenants: number; guarantors: number };
  }>({});
  const [showApartmentDropdown, setShowApartmentDropdown] = useState(false);
  const [showGroupSizeDropdown, setShowGroupSizeDropdown] = useState(false);

  const [selectedRows, setSelectedRows] = useState<Set<string>>(new Set());
  const [selectedTenants, setSelectedTenants] = useState<
    IAutomaticResponseHistory[]
  >([]);
  const [allEmails, setAllEmails] = useState<Set<string>>(new Set());
  const [showComposeEmail, setShowComposeEmail] = useState(false);

  const [editState, setEditState] = useState<{
    [key: string]: {
      tenants: number;
      guarantors: number;
      payment: string;
      bidding: string;
      changed: boolean;
    };
  }>({});
  const [paymentBidInfoMap, setPaymentBidInfoMap] = useState<{
    [key: string]: any;
  }>({});

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [isLoading, setIsLoading] = useState(true);

  const [showMemberMatcher, setShowMemberMatcher] = useState(
    initialTab === "matcher",
  );

  const [showAppfolioUnsignedList, setShowAppfolioUnsignedList] = useState(
    initialTab === "unsigned",
  );

  const [showPublicTenantLeads, setShowPublicTenantLeads] = useState(
    initialTab === "public-leads",
  );

  const [showBankDetails, setShowBankDetails] = useState(
    initialTab === "bank-details",
  );

  const [showMobileFilters, setShowMobileFilters] = useState(true);

  const updateTab = (tab: string) => {
    const newSearch = tab ? `?tab=${tab}` : "";
    navigate({ search: newSearch }, { replace: true });
    if (tab === "matcher") {
      setShowMemberMatcher(true);
      setShowAppfolioUnsignedList(false);
      setShowPublicTenantLeads(false);
      setShowBankDetails(false);
    } else if (tab === "unsigned") {
      setShowMemberMatcher(false);
      setShowAppfolioUnsignedList(true);
      setShowPublicTenantLeads(false);
      setShowBankDetails(false);
    } else if (tab === "public-leads") {
      setShowMemberMatcher(false);
      setShowAppfolioUnsignedList(false);
      setShowPublicTenantLeads(true);
      setShowBankDetails(false);
    } else if (tab === "bank-details") {
      setShowMemberMatcher(false);
      setShowAppfolioUnsignedList(false);
      setShowPublicTenantLeads(false);
      setShowBankDetails(true);
    } else {
      setShowMemberMatcher(false);
      setShowAppfolioUnsignedList(false);
      setShowPublicTenantLeads(false);
      setShowBankDetails(false);
    }
  };

  const getPaginatedData = () => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredMembers.slice(startIndex, endIndex);
  };

  const totalPages = Math.ceil(filteredMembers.length / rowsPerPage);

  const getEditDistance = useCallback((str1: string, str2: string): number => {
    const matrix = Array(str2.length + 1)
      .fill(null)
      .map(() => Array(str1.length + 1).fill(0));

    for (let i = 0; i <= str2.length; i++) matrix[i][0] = i;
    for (let j = 0; j <= str1.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= str2.length; i++) {
      for (let j = 1; j <= str1.length; j++) {
        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1,
          );
        }
      }
    }

    return matrix[str2.length][str1.length];
  }, []);

  const getStringSimilarity = useCallback(
    (str1: string, str2: string): number => {
      if (str1 === str2) return 1.0;
      if (!str1 || !str2) return 0;

      const s1 = str1.toLowerCase();
      const s2 = str2.toLowerCase();

      if (s1 === s2) return 1.0;

      const lengthDiff = Math.abs(s1.length - s2.length);
      const maxLength = Math.max(s1.length, s2.length);

      if (lengthDiff / maxLength > 0.7) return 0;

      if (s1.includes(s2) || s2.includes(s1)) {
        const longer = s1.length > s2.length ? s1 : s2;
        const shorter = s1.length > s2.length ? s2 : s1;
        return shorter.length / longer.length;
      }

      const editDistance = getEditDistance(s1, s2);
      return maxLength === 0 ? 1.0 : (maxLength - editDistance) / maxLength;
    },
    [getEditDistance],
  );

  const normalizeName = useCallback((name: string): string => {
    return (
      name
        ?.toLowerCase()
        .replace(/[^\w\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim() || ""
    );
  }, []);

  const isNameMatch = useCallback(
    (
      memberFirstName: string,
      memberLastName: string,
      compareName: string,
    ): { isMatch: boolean; confidence: number } => {
      if (!compareName || (!memberFirstName && !memberLastName)) {
        return { isMatch: false, confidence: 0 };
      }

      const memberFirst = normalizeName(memberFirstName);
      const memberLast = normalizeName(memberLastName);
      const compareWords = normalizeName(compareName)
        .split(" ")
        .filter((w) => w.length > 1);

      const memberWords = [memberFirst, memberLast].filter((w) => w.length > 1);

      let wordMatches = 0;
      for (const memberWord of memberWords) {
        const bestMatch = Math.max(
          ...compareWords.map((word) => getStringSimilarity(memberWord, word)),
        );
        if (bestMatch > 0.7) wordMatches++;
      }

      const confidence =
        memberWords.length > 0 ? wordMatches / memberWords.length : 0;
      const isMatch =
        confidence > 0.7 ||
        (wordMatches >= Math.min(2, memberWords.length) && confidence > 0.5);

      return { isMatch, confidence: Math.min(confidence, 1.0) };
    },
    [normalizeName, getStringSimilarity],
  );

  const calculateMappedMembers = useCallback(
    (
      info: AutoResponseDetailsinfo,
      appfolioData: IPublicTenantLead[],
      apartmentName: string,
      inquiryPerson: any,
      publicLeads: any[],
    ) => {
      const normalizeApt = (name: string) =>
        name
          ?.toLowerCase()
          .replace(/apt|#|unit/g, "")
          .replace(/\s+/g, "")
          .trim() || "";
      const groupApt = normalizeApt(apartmentName);

      const groupMembers = info?.memberAndGaurantorInfo || [];

      const isInquiryInGroup = groupMembers.some(
        (m) =>
          (m.email &&
            m.email.toLowerCase().trim() ===
              inquiryPerson.email?.toLowerCase().trim()) ||
          m.name.toLowerCase().trim() ===
            `${inquiryPerson.firstName} ${inquiryPerson.lastName}`
              .toLowerCase()
              .trim(),
      );

      const allMembersToProcess = [...groupMembers];
      if (!isInquiryInGroup) {
        allMembersToProcess.push({
          id: inquiryPerson.id,
          name: `${inquiryPerson.firstName} ${inquiryPerson.lastName}`,
          email: inquiryPerson.email,
          isGuarantor: false,
          appfolioId: null,
        } as any);
      }

      const isMappedMember = (member: MemberGuarantorInfo) =>
        !!member.appfolioId ||
        !!member.mappedTo?.id ||
        !!member.groupOccupantId ||
        !!member.mappedToGroupOccupant?.id;

      const mappedMembers = allMembersToProcess.filter(isMappedMember).length;

      return mappedMembers;
    },
    [],
  );

  const getMappedMemberBreakdown = useCallback(
    (info: AutoResponseDetailsinfo, inquiryPerson: any) => {
      const groupMembers = info?.memberAndGaurantorInfo || [];

      const isInquiryInGroup = groupMembers.some(
        (m) =>
          (m.email &&
            m.email.toLowerCase().trim() ===
              inquiryPerson.email?.toLowerCase().trim()) ||
          m.name.toLowerCase().trim() ===
            `${inquiryPerson.firstName} ${inquiryPerson.lastName}`
              .toLowerCase()
              .trim(),
      );

      const allMembersToProcess = [...groupMembers];
      if (!isInquiryInGroup) {
        allMembersToProcess.push({
          id: inquiryPerson.id,
          name: `${inquiryPerson.firstName} ${inquiryPerson.lastName}`,
          email: inquiryPerson.email,
          isGuarantor: false,
          appfolioId: null,
        } as any);
      }

      const isMappedMember = (member: MemberGuarantorInfo) =>
        !!member.appfolioId ||
        !!member.mappedTo?.id ||
        !!member.groupOccupantId ||
        !!member.mappedToGroupOccupant?.id;

      return {
        mappedMembers: allMembersToProcess.filter(isMappedMember).length,
        mappedTenants: allMembersToProcess.filter(
          (member) => !member.isGuarantor && isMappedMember(member),
        ).length,
        mappedGuarantors: allMembersToProcess.filter(
          (member) => member.isGuarantor && isMappedMember(member),
        ).length,
      };
    },
    [],
  );

  const getProvidedMembersCountForMapping = useCallback(
    (info: AutoResponseDetailsinfo, inquiryPerson: any) => {
      const groupMembers = info?.memberAndGaurantorInfo || [];

      const isInquiryInGroup = groupMembers.some(
        (m) =>
          (m.email &&
            m.email.toLowerCase().trim() ===
              inquiryPerson.email?.toLowerCase().trim()) ||
          m.name.toLowerCase().trim() ===
            `${inquiryPerson.firstName} ${inquiryPerson.lastName}`
              .toLowerCase()
              .trim(),
      );

      // Include inquiry person if they are not yet present in the form payload.
      return isInquiryInGroup ? groupMembers.length : groupMembers.length + 1;
    },
    [],
  );

  const isMemberMapped = useCallback(
    (
      member: any,
      appfolioData: IPublicTenantLead[],
      apartmentName: string,
      publicLeads: any[],
    ) => {
      return !!member.appfolioId ||
        !!member.mappedTo?.id ||
        !!member.groupOccupantId ||
        !!member.mappedToGroupOccupant?.id;
    },
    [],
  );

  const getUniqueApartmentNames = (): string[] => {
    return Array.from(
      new Set(automaticResponseHistoryList.map((m) => m.title)),
    ).sort();
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest(".relative")) {
        setShowApartmentDropdown(false);
        setShowGroupSizeDropdown(false);
        setShowShowingStatusDropdown(false);
        setShowExternalStatusDropdown(false);
        setShowAppfolioStatusDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setShowMobileFilters(true);
  }, [
    showMemberMatcher,
    showAppfolioUnsignedList,
    showPublicTenantLeads,
    showBankDetails,
  ]);

  const getExpectedGroupCounts = useCallback(
    (bedrooms: number, dbEntry?: any) => {
      const tenants = Math.max(0, dbEntry?.tenants ?? bedrooms);
      // New rule: guarantors are no longer tied to bedrooms; minimum expected is 0.
      const guarantors = Math.max(0, dbEntry?.guarantors ?? 0);
      return {
        tenants,
        guarantors,
        totalMembers: tenants + guarantors,
      };
    },
    [],
  );

  const getLatestUnique = useCallback(
    (data: IAutomaticResponseHistory[]): IAutomaticResponseHistory[] => {
      return Object.values(
        data.reduce<Record<string, IAutomaticResponseHistory>>((acc, item) => {
          // Group by both Tenant and Listing to ensure separate entries for different apartment bookings
          const key = `${item.idProspectiveTenant}|${item.listingID}`;

          if (
            !acc[key] ||
            new Date(item.sentDate) > new Date(acc[key].sentDate)
          ) {
            acc[key] = item;
          }

          return acc;
        }, {}),
      );
    },
    [],
  );

  const loadMembersData = useCallback(async () => {
    setIsLoading(true);
    try {
      const [
        paged,
        publicLeadsData,
        allMemberInfos,
        allPaymentBidInfo,
        confirmedAssignments,
      ] = await Promise.all([
        fetchAutomaticResponseHistory("All", false, 0, 1000),
        fetchPublicTenantLeads(),
        GetAllMemberAndGuarantor(
          "00000000-0000-0000-0000-000000000000",
          true,
        ),
        fetchPaymentAndBidInfo("00000000-0000-0000-0000-000000000000", true),
        fetchConfirmedAppfolioAssignments(),
      ]);

      // Transform public leads for matching
      const transformedPublicLeads = (publicLeadsData || []).map(
        (lead: any) => ({
          id: lead.id,
          idProspectiveTenant: lead.id,
          firstName: lead.name.split(" ")[0] || "",
          lastName: lead.name.split(" ").slice(1).join(" ") || "",
          name: lead.name,
          email: lead.email,
          phone: lead.phoneNo,
          title: lead.apartmentName,
          sentDate: lead.createdAtUtc,
          confirmed: true,
          isPublicLead: true,
        }),
      );

      // Handle paged data safely
      const data =
        paged && paged.items ? paged.items : Array.isArray(paged) ? paged : [];

      const mergedData = [...data];
      const latestUnique = getLatestUnique(mergedData);

      setAutomaticResponseHistoryList(latestUnique);
      setPublicLeads(publicLeadsData || []);
      setFilteredMembers(latestUnique);
      setAllEmails(
        new Set(
          latestUnique.map(
            (row: { email: any; title: any }) => `${row.email}|${row.title}`,
          ),
        ),
      );

      const infoMap: { [key: string]: AutoResponseDetailsinfo } = {};
      if (Array.isArray(allMemberInfos)) {
        allMemberInfos.forEach((info: any) => {
          infoMap[info.id] = {
            id: info.id,
            confirmed: info.confirmed,
            sentDate: info.sentDate,
            startTime: info.startTime,
            endTime: info.endTime,
            numOfBedrooms: info.numOfBedrooms,
            memberAndGaurantorInfo: Array.isArray(info.memberAndGaurantorInfo)
              ? info.memberAndGaurantorInfo.map((m: any) => ({
                  id: m.Id || m.id || "",
                  name: m.Name || m.name || "",
                  email: m.Email || m.email || "",
                  isGuarantor: m.IsGuarantor ?? m.isGuarantor ?? false,
                  appfolioId:
                    m.AppfolioId ||
                    m.appfolioId ||
                    m.MappedTo?.id ||
                    m.mappedTo?.id ||
                    "",
                  // Source 2 (group-aware scrape) — without this, a member mapped only
                  // via GroupOccupantId (no AppfolioId at all) was silently dropped from
                  // every "is this member mapped" check fed by this bulk fetch, even
                  // though the same member shows correctly mapped wherever the data
                  // comes from GetTenantMappings instead (e.g. the matching drawer).
                  groupOccupantId:
                    m.GroupOccupantId ||
                    m.groupOccupantId ||
                    m.MappedToGroupOccupant?.id ||
                    m.mappedToGroupOccupant?.id ||
                    "",
                  isConfirmed: m.IsConfirmed ?? m.isConfirmed ?? false,
                  isManuallyConfirmed:
                    m.IsManuallyConfirmed ?? m.isManuallyConfirmed ?? false,
                }))
              : [],
          };
        });
      }

      setMemberGuarantorInfos(infoMap);
      setAppfolioMembers(publicLeadsData || []);
      setConfirmedAppfolioAssignments(confirmedAssignments || []);

      const paymentMap: any = {};
      const updatedEdit: typeof editState = {};
      const mapping: MappingInfo = {};

      const paymentBidMap = new Map();
      if (allPaymentBidInfo && Array.isArray(allPaymentBidInfo)) {
        allPaymentBidInfo.forEach((item: any) => {
          paymentBidMap.set(item.arhID, item);
        });
      }

      latestUnique.forEach(
        (member: {
          id: string;
          title: string;
          firstName: string;
          lastName: string;
          email: string;
        }) => {
          const info = infoMap[member.id] || {
            id: member.id,
            memberAndGaurantorInfo: [],
            numOfBedrooms: 0,
            confirmed: false,
            sentDate: null,
            startTime: null,
            endTime: null,
          };

          const bedrooms = info.numOfBedrooms || 0;
          const dbEntry = paymentBidMap.get(member.id) || null;

          const { tenants, guarantors, totalMembers } = getExpectedGroupCounts(
            bedrooms,
            dbEntry,
          );

          updatedEdit[member.id] = {
            tenants,
            guarantors,
            payment: dbEntry?.payment ?? "not paid",
            bidding: dbEntry?.bidding ?? "No Bid",
            changed: false,
          };

          paymentMap[member.id] = dbEntry;
          const mappedMembers = calculateMappedMembers(
            info,
            publicLeadsData || [],
            member.title,
            member,
            transformedPublicLeads,
          );
          const providedMembersCount = getProvidedMembersCountForMapping(
            info,
            member,
          );
          const mappingTotalMembers = Math.max(
            totalMembers,
            providedMembersCount,
          );
          mapping[member.id] = {
            totalMembers,
            mappingTotalMembers,
            mappedMembers,
          };
        },
      );

      setEditState(updatedEdit);
      setMappingInfo(mapping);
      setPaymentBidInfoMap(paymentMap);
    } catch (e) {
      console.error("Error fetching data", e);
    } finally {
      setIsLoading(false);
    }
  }, [
    calculateMappedMembers,
    getExpectedGroupCounts,
    getLatestUnique,
    getProvidedMembersCountForMapping,
  ]);

  useEffect(() => {
    void loadMembersData();
  }, [loadMembersData]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    nameFilter,
    apartmentFilterOptions,
    groupSizeFilterOptions,
    showingStatusFilter,
    externalStatusFilter,
    appfolioStatusFilter,
  ]);

  const getShowingStatus = useCallback(
    (member: IAutomaticResponseHistory) => {
      const info = memberGuarantorInfos[member.id];
      if (!info) return "Loading...";
      const slotStart = DateTime.fromISO(info.startTime || "");
      const seen = info.confirmed && DateTime.local() > slotStart;
      if (seen) return "Seen";
      if (info.confirmed) return "Confirmed";
      return "Inquired";
    },
    [memberGuarantorInfos],
  );

  const getGroupCompletionStatus = useCallback(
    (
      actualTenants: number,
      actualGuarantors: number,
      expectedTenants: number,
      expectedGuarantors: number,
    ) => {
      if (
        actualTenants >= expectedTenants &&
        actualGuarantors >= expectedGuarantors
      ) {
        return "Completed";
      }

      if (actualTenants === 0 && actualGuarantors === 0) {
        return "Not Started";
      }

      return "Partial";
    },
    [],
  );

  const getExternalFormStatus = useCallback(
    (member: IAutomaticResponseHistory) => {
      const info = memberGuarantorInfos[member.id];
      const members = info?.memberAndGaurantorInfo || [];
      const actualTenants = members.filter((m) => !m.isGuarantor).length;
      const actualGuarantors = members.filter((m) => m.isGuarantor).length;

      // External form expects tenant count to follow the edited table value,
      // while defaulting to the bedroom count when no edit exists yet.
      const edit = editState[member.id];
      const expectedTenants = Math.max(
        0,
        edit?.tenants ?? info?.numOfBedrooms ?? 0,
      );

      // Keep guarantor expectation in sync with latest editable value,
      // with minimum expected guarantors set to 0 (editable by user).
      const expectedGuarantors = Math.max(0, edit?.guarantors ?? 0);

      const effectiveExpectedTenants = Math.max(expectedTenants, actualTenants);
      const effectiveExpectedGuarantors = Math.max(
        expectedGuarantors,
        actualGuarantors,
      );

      const actualMembers = actualTenants + actualGuarantors;
      const expectedMembers =
        effectiveExpectedTenants + effectiveExpectedGuarantors;

      if (actualMembers === 0) {
        return { status: "Not Started", color: "bg-gray-100 text-gray-800" };
      }

      if (expectedMembers === 0) {
        return { status: "Partial", color: "bg-yellow-100 text-yellow-800" };
      }

      const status =
        actualTenants >= effectiveExpectedTenants &&
        actualGuarantors >= effectiveExpectedGuarantors
          ? "Completed"
          : "Partial";

      const color =
        status === "Completed"
          ? "bg-green-100 text-green-800"
          : "bg-yellow-100 text-yellow-800";
      return { status, color };
    },
    [editState, memberGuarantorInfos],
  );

  const getAppfolioStatus = useCallback(
    (member: IAutomaticResponseHistory) => {
      const info = memberGuarantorInfos[member.id];
      const members = info?.memberAndGaurantorInfo || [];
      const actualMemberCount = members.length;
      const mappedInfo = getMappedMemberBreakdown(info, member);

      const externalStatus = getExternalFormStatus(member);

      const edit = editState[member.id];
      const expectedTenants = Math.max(
        0,
        edit?.tenants ?? info?.numOfBedrooms ?? 0,
      );
      const expectedGuarantors = Math.max(0, edit?.guarantors ?? 0);

      const providedTenants = (info?.memberAndGaurantorInfo || []).filter(
        (m) => !m.isGuarantor,
      ).length;
      const providedGuarantors = (info?.memberAndGaurantorInfo || []).filter(
        (m) => m.isGuarantor,
      ).length;

      const effectiveExpectedTenants = Math.max(
        expectedTenants,
        providedTenants,
      );
      const effectiveExpectedGuarantors = Math.max(
        expectedGuarantors,
        providedGuarantors,
      );

      let status = "Not Started";

      if (actualMemberCount > 0) {
        status = getGroupCompletionStatus(
          mappedInfo.mappedTenants,
          mappedInfo.mappedGuarantors,
          effectiveExpectedTenants,
          effectiveExpectedGuarantors,
        );
      }

      // If external form is not filled, Appfolio matching shouldn't be "Completed"
      // If external form is not started, Appfolio cannot be Partial/Completed
      if (externalStatus.status === "Not Started") {
        status = "Not Started";
      } else if (
        externalStatus.status === "Partial" &&
        status === "Completed"
      ) {
        // If external is partially filled, Appfolio should not be Completed
        status = "Partial";
      }

      const color =
        status === "Not Started"
          ? "bg-gray-100 text-gray-800"
          : status === "Completed"
            ? "bg-green-100 text-green-800"
            : "bg-yellow-100 text-yellow-800";
      return { status, color };
    },
    [
      getExternalFormStatus,
      getGroupCompletionStatus,
      editState,
      memberGuarantorInfos,
      getMappedMemberBreakdown,
    ],
  );

  const getVenmoStatus = useCallback(
    (member: IAutomaticResponseHistory) => {
      const info = memberGuarantorInfos[member.id];
      const members = info?.memberAndGaurantorInfo || [];
      const actualMemberCount = members.length;

      const externalStatus = getExternalFormStatus(member);

      const edit = editState[member.id];
      const expectedTenants = Math.max(
        0,
        edit?.tenants ?? info?.numOfBedrooms ?? 0,
      );
      const expectedGuarantors = Math.max(0, edit?.guarantors ?? 0);

      const providedTenants = members.filter((m) => !m.isGuarantor).length;
      const providedGuarantors = members.filter((m) => m.isGuarantor).length;

      const effectiveExpectedTenants = Math.max(
        expectedTenants,
        providedTenants,
      );
      const effectiveExpectedGuarantors = Math.max(
        expectedGuarantors,
        providedGuarantors,
      );

      const confirmedTenants = members.filter(
        (m) => !m.isGuarantor && m.isManuallyConfirmed,
      ).length;
      const confirmedGuarantors = members.filter(
        (m) => m.isGuarantor && m.isManuallyConfirmed,
      ).length;

      let status = "Not Started";

      if (actualMemberCount > 0) {
        status = getGroupCompletionStatus(
          confirmedTenants,
          confirmedGuarantors,
          effectiveExpectedTenants,
          effectiveExpectedGuarantors,
        );
      }

      // Mirror Appfolio status gating: Venmo confirmation can't be ahead of the external form.
      if (externalStatus.status === "Not Started") {
        status = "Not Started";
      } else if (
        externalStatus.status === "Partial" &&
        status === "Completed"
      ) {
        status = "Partial";
      }

      const color =
        status === "Not Started"
          ? "bg-gray-100 text-gray-800"
          : status === "Completed"
            ? "bg-green-100 text-green-800"
            : "bg-yellow-100 text-yellow-800";
      return { status, color };
    },
    [getExternalFormStatus, getGroupCompletionStatus, editState, memberGuarantorInfos],
  );

  const getGroupSize = useCallback(
    (member: IAutomaticResponseHistory) => {
      const mapping =
        mappingInfo[member.id] || mappingInfo[member.idProspectiveTenant] || {};

      const providedMembers =
        memberGuarantorInfos[member.id]?.memberAndGaurantorInfo?.length || 0;

      // Determine expected members from mapping (preferred), fallback to totalMembers or bedrooms or editState
      const expectedFromMapping =
        mapping?.mappingTotalMembers ?? mapping?.totalMembers ?? 0;

      const edit = editState[member.id];
      const expectedFromEdit = edit
        ? Math.max(0, edit.tenants || 0) + Math.max(0, edit.guarantors || 0)
        : 0;

      const expected =
        expectedFromMapping ||
        expectedFromEdit ||
        memberGuarantorInfos[member.id]?.numOfBedrooms ||
        0;

      return Math.max(expected, providedMembers);
    },
    [memberGuarantorInfos, mappingInfo, editState],
  );

  const isMandatoryWorkflow = useCallback(
    (member: IAutomaticResponseHistory) =>
      member.workflowType === 0 || member.isMandatory,
    [],
  );

  const memoizedCalculations = useMemo(() => {
    const calculations: {
      [key: string]: {
        showingStatus: string;
        externalFormStatus: { status: string; color: string };
        appfolioStatus: { status: string; color: string };
        venmoStatus: { status: string; color: string };
        groupSize: number;
      };
    } = {};

    automaticResponseHistoryList.forEach((member) => {
      calculations[member.id] = {
        showingStatus: getShowingStatus(member),
        externalFormStatus: getExternalFormStatus(member),
        appfolioStatus: getAppfolioStatus(member),
        venmoStatus: getVenmoStatus(member),
        groupSize: getGroupSize(member),
      };
    });

    return calculations;
  }, [
    automaticResponseHistoryList,
    getAppfolioStatus,
    getVenmoStatus,
    getExternalFormStatus,
    getGroupSize,
    getShowingStatus,
  ]);

  const onSave = async (id: string) => {
    try {
      const saveData = { arhId: id, ...editState[id] };
      await savePaymentAndBidInfo(saveData);
      setPaymentBidInfoMap((prev) => ({ ...prev, [id]: saveData }));
      setEditState((prev) => ({
        ...prev,
        [id]: { ...prev[id], changed: false },
      }));
    } catch (e) {
      console.error("Save failed for", id, e);
    }
  };

  const clearFilters = () => {
    setNameFilter("");
    setApartmentFilterOptions([]);
    setGroupSizeFilterOptions([]);
    setShowingStatusFilter([]);
    setExternalStatusFilter([]);
    setAppfolioStatusFilter([]);
    setShowApartmentDropdown(false);
    setShowGroupSizeDropdown(false);
    setShowShowingStatusDropdown(false);
    setShowExternalStatusDropdown(false);
    setShowAppfolioStatusDropdown(false);
  };

  const toggleExpand = (id: string) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));

    if (!expandedRows[id] && !memberGuarantorInfos[id]) {
      fetchMemberGroupDetails(id);
    }
  };

  // Hover-to-preview state: shows the group details panel in a floating
  // popup when hovering over a row, instead of the click-to-expand row.
  const [hoveredMemberId, setHoveredMemberId] = useState<string | null>(null);
  const [hoverPopupRect, setHoverPopupRect] = useState<{
    top: number;
    left: number;
    width: number;
  } | null>(null);
  const hoverHideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const handleRowMouseEnter = (
    member: IAutomaticResponseHistory,
    e: React.MouseEvent<HTMLTableRowElement>,
  ) => {
    if (hoverHideTimeoutRef.current) {
      clearTimeout(hoverHideTimeoutRef.current);
      hoverHideTimeoutRef.current = null;
    }
    const rect = e.currentTarget.getBoundingClientRect();
    setHoverPopupRect({ top: rect.bottom, left: rect.left, width: rect.width });
    setHoveredMemberId(member.id);

    if (!memberGuarantorInfos[member.id]) {
      fetchMemberGroupDetails(member.id);
    }
  };

  const handleRowMouseLeave = () => {
    hoverHideTimeoutRef.current = setTimeout(() => {
      setHoveredMemberId(null);
    }, 200);
  };

  const handlePopupMouseEnter = () => {
    if (hoverHideTimeoutRef.current) {
      clearTimeout(hoverHideTimeoutRef.current);
      hoverHideTimeoutRef.current = null;
    }
  };

  const handlePopupMouseLeave = () => {
    setHoveredMemberId(null);
  };

  // arhId of the group to pre-select when navigating to the Unsigned List
  // (Matcher) view by clicking a row.
  const [unsignedListArhId, setUnsignedListArhId] = useState<string>("");

  const openGroupInUnsignedList = (member: IAutomaticResponseHistory) => {
    if (hoverHideTimeoutRef.current) {
      clearTimeout(hoverHideTimeoutRef.current);
      hoverHideTimeoutRef.current = null;
    }
    setHoveredMemberId(null);
    setDrawerArh(null);
    setShowMobileFilters(true);
    setUnsignedListArhId(member.id);
    updateTab("unsigned");
  };

  // Group whose details/mapping drawer is currently open (default view).
  const [drawerArh, setDrawerArh] = useState<IAutomaticResponseHistory | null>(
    null,
  );

  const openGroupDetailsDrawer = (member: IAutomaticResponseHistory) => {
    if (hoverHideTimeoutRef.current) {
      clearTimeout(hoverHideTimeoutRef.current);
      hoverHideTimeoutRef.current = null;
    }
    setHoveredMemberId(null);
    setShowMobileFilters(false);
    setDrawerArh(member);
  };

  const closeGroupDetailsDrawer = () => {
    setDrawerArh(null);
    setShowMobileFilters(true);
  };

  // Renders the same "Showing Status & Progress" + "Tenant & Guarantor
  // Matching" content used by the (now commented-out) click-to-expand row,
  // reused here for the hover popup.
  const renderGroupDetailsContent = (member: IAutomaticResponseHistory) => (
    <div className="flex flex-col gap-2.5 px-3 py-3 max-w-full overflow-x-hidden">
      {/* 1. SHOWING STATUS */}
      <div className="bg-white p-2.5 rounded-lg border border-gray-200 min-w-0">
        <h5 className="font-semibold text-gray-900 mb-1.5 text-xs">
          📊 Showing Status & Progress
        </h5>
        {memberGuarantorInfos[member.id] ? (
          <div className="overflow-x-auto min-w-0">
            <MemberStatusFlow
              key={member.id}
              arhid={member.id}
              info={memberGuarantorInfos[member.id]}
              mappingInfo={mappingInfo[member.id]}
              appointmentStatus={member.appointmentStatus}
              isMandatory={isMandatoryWorkflow(member)}
              getExternalFormStatus={() => getExternalFormStatus(member)}
              getAppfolioStatus={() => getAppfolioStatus(member)}
              compact
            />
          </div>
        ) : (
          <div className="text-xs text-gray-500">Loading status flow...</div>
        )}
      </div>

      {/* 2. MAPPING */}
      <div className="bg-white p-2.5 rounded-lg border border-gray-200 min-w-0">
        <h5 className="font-semibold text-gray-900 mb-1.5 text-xs">
          🔗 Tenant & Guarantor Matching
        </h5>

        <div className="overflow-x-auto min-w-0">
          {/* Editable mapping view - disabled for the read-only hover popup.
              To revert to the editable view, change `false &&` below to
              `true &&` (or remove the wrapping condition). */}
          {false && (
            <TenantMapping
              key={member.id}
              arhid={member.id}
              appfolioMembers={appfolioMembers}
              memberGuarantorInfo={memberGuarantorInfos[member.id]}
              onMappingsUpdated={loadMembersData}
              prospectiveTenant={{
                name: `${member.firstName} ${member.lastName}`,
                email: member.email,
                phone: member.phone,
              }}
              calculateMappedMembers={calculateMappedMembers}
              isNameMatch={isNameMatch}
              getStringSimilarity={getStringSimilarity}
              getEditDistance={getEditDistance}
              normalizeName={normalizeName}
              tenantEmail={member.email}
              tenantName={`${member.firstName} ${member.lastName}`}
              apartmentName={member.title}
            />
          )}

          {/* Read-only info view: shows mapping status without allowing
              the user to change/select mappings from the hover popup.
              key={member.id} forces a full remount per card — without it,
              hovering quickly across rows keeps the same TenantMapping
              instance mounted with a changing arhid prop, and a slow
              in-flight fetch from the previous card can resolve after the
              swap and overwrite the new card's display with stale data. */}
          <TenantMapping
            key={member.id}
            arhid={member.id}
            appfolioMembers={appfolioMembers}
            memberGuarantorInfo={memberGuarantorInfos[member.id]}
            prospectiveTenant={{
              name: `${member.firstName} ${member.lastName}`,
              email: member.email,
              phone: member.phone,
            }}
            calculateMappedMembers={calculateMappedMembers}
            isNameMatch={isNameMatch}
            getStringSimilarity={getStringSimilarity}
            getEditDistance={getEditDistance}
            normalizeName={normalizeName}
            tenantEmail={member.email}
            tenantName={`${member.firstName} ${member.lastName}`}
            apartmentName={member.title}
            readOnly
            compact
          />
        </div>
      </div>
    </div>
  );

  const fetchMemberGroupDetails = async (arhId: string) => {
    try {
      const memberData = await GetMemberAndGuarntor(arhId);
      if (memberData && Array.isArray(memberData)) {
        setMemberGuarantorInfos((prev) => ({
          ...prev,
          [arhId]: {
            id: arhId,
            confirmed: false,
            sentDate: null,
            startTime: null,
            endTime: null,
            numOfBedrooms: 0,
            memberAndGaurantorInfo: memberData.map((m: any) => ({
              id: m.Id || m.id || "",
              name: m.Name || m.name || "",
              email: m.Email || m.email || "",
              isGuarantor: m.IsGuarantor ?? m.isGuarantor ?? false,
              appfolioId:
                m.AppfolioId ||
                m.appfolioId ||
                m.MappedTo?.id ||
                m.mappedTo?.id ||
                "",
              isManuallyConfirmed:
                m.IsManuallyConfirmed ?? m.isManuallyConfirmed ?? false,
            })),
          } as AutoResponseDetailsinfo,
        }));
      }
    } catch (error) {
      console.error("Error fetching member group details:", error);
    }
  };

  const createRowKey = (email: string, dept: string) => `${email}|${dept}`;

  useEffect(() => {
    let filtered = automaticResponseHistoryList;

    if (nameFilter.trim()) {
      filtered = filtered.filter((member) =>
        `${member.firstName} ${member.lastName}`
          .toLowerCase()
          .includes(nameFilter.toLowerCase()),
      );
    }
    if (apartmentFilterOptions.length > 0) {
      filtered = filtered.filter((member) =>
        apartmentFilterOptions.includes(member.title),
      );
    }
    if (groupSizeFilterOptions.length > 0) {
      filtered = filtered.filter((member) =>
        groupSizeFilterOptions.includes(
          memoizedCalculations[member.id]?.groupSize?.toString() || "0",
        ),
      );
    }
    if (showingStatusFilter.length > 0) {
      filtered = filtered.filter((member) =>
        showingStatusFilter.includes(
          memoizedCalculations[member.id]?.showingStatus || "",
        ),
      );
    }
    if (externalStatusFilter.length > 0) {
      filtered = filtered.filter((member) =>
        externalStatusFilter.includes(
          memoizedCalculations[member.id]?.externalFormStatus.status || "",
        ),
      );
    }
    if (appfolioStatusFilter.length > 0) {
      filtered = filtered.filter((member) =>
        appfolioStatusFilter.includes(
          memoizedCalculations[member.id]?.appfolioStatus.status || "",
        ),
      );
    }
    setFilteredMembers(filtered);
  }, [
    automaticResponseHistoryList,
    nameFilter,
    apartmentFilterOptions,
    groupSizeFilterOptions,
    showingStatusFilter,
    externalStatusFilter,
    appfolioStatusFilter,
    memoizedCalculations,
  ]);

  return (
    <div className="h-[calc(100vh-3rem)] flex flex-col bg-gray-50 -mx-4 sm:-mx-6 lg:-mx-8">
      <ComposeEmail
        emails={
          new Set(
            Array.from(allEmails).map((emailStr) => {
              const [email, dept] = emailStr.split("|");
              return { email, dept };
            }),
          )
        }
        open={showComposeEmail}
        setOpen={setShowComposeEmail}
        selectedEmails={
          new Set(
            Array.from(selectedRows).map((rowKey) => {
              const [email, dept] = rowKey.split("|");
              return { email, dept };
            }),
          )
        }
      />

      <div className="flex-shrink-0 bg-white border-b border-gray-200 shadow-sm">
        <div className="px-3 md:px-6 py-3 md:py-4 flex items-center justify-between">
          <div className="flex items-center space-x-2 md:space-x-4">
            <h2 className="text-lg md:text-2xl font-semibold text-black">
              {showMemberMatcher
                ? "Tenant Group Matches"
                : showAppfolioUnsignedList
                  ? "Appfolio Unsigned List"
                  : showPublicTenantLeads
                    ? "Public Tenant Leads"
                    : showBankDetails
                      ? "Bank Details"
                      : "Tenants Group Details"}
            </h2>
            <div className="flex items-center space-x-1 md:space-x-2">
              <button
                onClick={() => updateTab(showMemberMatcher ? "" : "matcher")}
                className={`inline-flex items-center px-2 md:px-3 py-1 md:py-1.5 border border-gray-300 rounded-md text-xs md:text-sm font-medium transition-colors duration-200 ${
                  showMemberMatcher
                    ? "bg-blue-100 text-blue-700 border-blue-300"
                    : "bg-white text-gray-700 hover:bg-gray-50"
                }`}
              >
                <svg
                  className="w-3 h-3 md:w-4 md:h-4 md:mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                  />
                </svg>
                Matcher View
              </button>
              <button
                onClick={() =>
                  updateTab(showAppfolioUnsignedList ? "" : "unsigned")
                }
                className={`inline-flex items-center px-2 md:px-3 py-1 md:py-1.5 border border-gray-300 rounded-md text-xs md:text-sm font-medium transition-colors duration-200 ${
                  showAppfolioUnsignedList
                    ? "bg-green-100 text-green-700 border-green-300"
                    : "bg-white text-gray-700 hover:bg-gray-50"
                }`}
              >
                <svg
                  className="w-3 h-3 md:w-4 md:h-4 md:mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                Unsigned List
              </button>
              <button
                onClick={() =>
                  updateTab(showPublicTenantLeads ? "" : "public-leads")
                }
                className={`inline-flex items-center px-2 md:px-3 py-1 md:py-1.5 border border-gray-300 rounded-md text-xs md:text-sm font-medium transition-colors duration-200 ${
                  showPublicTenantLeads
                    ? "bg-green-100 text-green-700 border-green-300"
                    : "bg-white text-gray-700 hover:bg-gray-50"
                }`}
              >
                <svg
                  className="w-3 h-3 md:w-4 md:h-4 md:mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                  />
                </svg>
                Public Tenant Leads
              </button>
              <button
                onClick={() => updateTab(showBankDetails ? "" : "bank-details")}
                className={`inline-flex items-center px-2 md:px-3 py-1 md:py-1.5 border border-gray-300 rounded-md text-xs md:text-sm font-medium transition-colors duration-200 ${
                  showBankDetails
                    ? "bg-purple-100 text-purple-700 border-purple-300"
                    : "bg-white text-gray-700 hover:bg-gray-50"
                }`}
              >
                <svg
                  className="w-3 h-3 md:w-4 md:h-4 md:mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2.25a1 1 0 01.5.125A6.02 6.02 0 0012 20.25A6.02 6.02 0 0016.75 9.125a1 1 0 01.5-.125H19a2 2 0 002-2z"
                  />
                </svg>
                Bank Details
              </button>
            </div>
          </div>
          {!showMemberMatcher &&
            !showAppfolioUnsignedList &&
            !showPublicTenantLeads &&
            !showBankDetails && (
              <button
                onClick={() => setShowComposeEmail(true)}
                className="bg-gradient-to-r from-green-400 to-teal-500 text-white text-xs md:text-sm font-medium py-1 px-2 md:px-3 rounded-full shadow hover:from-green-500 hover:to-teal-600 transition"
              >
                Send Email
              </button>
            )}
        </div>
      </div>

      {/* Main Content Area with Sidebar Layout */}
      <div className="flex-1 flex overflow-hidden">
        {showMemberMatcher ? (
          <div className="flex-1 bg-white overflow-hidden">
            <div className="h-full overflow-x-auto overflow-y-auto">
              <MemberMatcher
                memberGuarantorInfos={memberGuarantorInfos}
                mappingInfo={mappingInfo}
              />
            </div>
          </div>
        ) : showAppfolioUnsignedList ? (
          <AppfolioUnsignedList
            arhResponses={automaticResponseHistoryList}
            appfolioData={appfolioMembers}
            memberGuarantorInfos={memberGuarantorInfos}
            mappingInfo={mappingInfo}
            memoizedCalculations={memoizedCalculations}
            onMappingsUpdated={loadMembersData}
            initialSelectedArhId={unsignedListArhId}
            confirmedAppfolioAssignments={confirmedAppfolioAssignments}
          />
        ) : showPublicTenantLeads ? (
          <div className="flex-1 bg-white overflow-hidden">
            <div className="h-full overflow-x-auto overflow-y-auto">
              <PublicTenantLeads />
            </div>
          </div>
        ) : showBankDetails ? (
          <div className="flex-1 bg-white overflow-hidden">
            <div className="h-full overflow-x-auto overflow-y-auto">
              <BankDetailsPage />
            </div>
          </div>
        ) : (
          <>
            {/* Left Sidebar - Filters with Toggle */}
            <div className="relative flex">
              {/* Toggle Arrow Button */}
              <button
                onClick={() => setShowMobileFilters(!showMobileFilters)}
                className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-gray-600 text-white p-2 rounded-r-md shadow-lg hover:bg-gray-700 transition-all"
                style={{ left: showMobileFilters ? "256px" : "0" }}
              >
                {showMobileFilters ? (
                  <KeyboardArrowLeft className="w-5 h-5" />
                ) : (
                  <KeyboardArrowRight className="w-5 h-5" />
                )}
              </button>

              {/* Sidebar Content */}
              <div
                className={`bg-white border-r border-gray-200 shadow-sm overflow-y-auto transition-all duration-300 ${
                  showMobileFilters ? "w-64" : "w-0"
                }`}
              >
                <div className={`p-2 ${showMobileFilters ? "" : "hidden"}`}>
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-base font-medium text-gray-900">
                      Filters
                    </h3>
                    <button
                      onClick={clearFilters}
                      className="flex items-center text-sm text-blue-600 hover:text-blue-800 font-medium"
                      title="Reset Filters"
                    >
                      <RestartAltIcon className="w-4 h-4 mr-1" />
                      Reset
                    </button>
                  </div>

                  <div className="space-y-6">
                    {/* Name Filter */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Name
                      </label>
                      <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                        <input
                          type="text"
                          value={nameFilter}
                          onChange={(e) => setNameFilter(e.target.value)}
                          placeholder="Search by name..."
                          className="w-full pl-10 pr-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    </div>

                    {/* Apartment Filter */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Apartment
                      </label>
                      <div className="relative">
                        <button
                          onClick={() =>
                            setShowApartmentDropdown(!showApartmentDropdown)
                          }
                          className="w-full px-3 py-1 border border-gray-300 rounded-md text-sm text-left bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 flex items-center justify-between"
                        >
                          <span className="text-gray-700">
                            {apartmentFilterOptions.length > 0
                              ? `${apartmentFilterOptions.length} selected`
                              : "All"}
                          </span>
                          <KeyboardArrowDownIcon className="w-4 h-4 text-gray-400" />
                        </button>
                        {showApartmentDropdown && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto">
                            {getUniqueApartmentNames().map((aptName) => (
                              <div
                                key={aptName}
                                className="flex items-center px-3 py-2 hover:bg-gray-50"
                              >
                                <input
                                  type="checkbox"
                                  id={`apt-${aptName}`}
                                  checked={apartmentFilterOptions.includes(
                                    aptName,
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setApartmentFilterOptions([
                                        ...apartmentFilterOptions,
                                        aptName,
                                      ]);
                                    } else {
                                      setApartmentFilterOptions(
                                        apartmentFilterOptions.filter(
                                          (name) => name !== aptName,
                                        ),
                                      );
                                    }
                                  }}
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded mr-2"
                                />
                                <label
                                  htmlFor={`apt-${aptName}`}
                                  className="text-sm text-gray-700 cursor-pointer flex-1"
                                >
                                  {aptName}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Group Size
                      </label>
                      <div className="relative">
                        <button
                          onClick={() =>
                            setShowGroupSizeDropdown(!showGroupSizeDropdown)
                          }
                          className="w-full px-3 py-1 border border-gray-300 rounded-md text-sm text-left bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 flex items-center justify-between"
                        >
                          <span className="text-gray-700">
                            {groupSizeFilterOptions.length > 0
                              ? `${groupSizeFilterOptions.length} selected`
                              : "All"}
                          </span>
                          <KeyboardArrowDownIcon className="w-4 h-4 text-gray-400" />
                        </button>
                        {showGroupSizeDropdown && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto">
                            {["1", "2", "3", "4", "5", "6"].map((size) => (
                              <div
                                key={size}
                                className="flex items-center px-3 py-2 hover:bg-gray-50"
                              >
                                <input
                                  type="checkbox"
                                  id={`size-${size}`}
                                  checked={groupSizeFilterOptions.includes(
                                    size,
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setGroupSizeFilterOptions([
                                        ...groupSizeFilterOptions,
                                        size,
                                      ]);
                                    } else {
                                      setGroupSizeFilterOptions(
                                        groupSizeFilterOptions.filter(
                                          (s) => s !== size,
                                        ),
                                      );
                                    }
                                  }}
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded mr-2"
                                />
                                <label
                                  htmlFor={`size-${size}`}
                                  className="text-sm text-gray-700 cursor-pointer flex-1"
                                >
                                  {size}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Showing Status Filter */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Showing Status
                      </label>
                      <div className="relative">
                        <button
                          onClick={() =>
                            setShowShowingStatusDropdown(
                              !showShowingStatusDropdown,
                            )
                          }
                          className="w-full px-3 py-1 border border-gray-300 rounded-md text-sm text-left bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 flex items-center justify-between"
                        >
                          <span className="text-gray-700">
                            {showingStatusFilter.length > 0
                              ? `${showingStatusFilter.length} selected`
                              : "All"}
                          </span>
                          <KeyboardArrowDownIcon className="w-4 h-4 text-gray-400" />
                        </button>
                        {showShowingStatusDropdown && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto">
                            {["Inquired", "Confirmed", "Seen"].map((status) => (
                              <div
                                key={status}
                                className="flex items-center px-3 py-2 hover:bg-gray-50"
                              >
                                <input
                                  type="checkbox"
                                  id={`showing-${status}`}
                                  checked={showingStatusFilter.includes(status)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setShowingStatusFilter([
                                        ...showingStatusFilter,
                                        status,
                                      ]);
                                    } else {
                                      setShowingStatusFilter(
                                        showingStatusFilter.filter(
                                          (s) => s !== status,
                                        ),
                                      );
                                    }
                                  }}
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded mr-2"
                                />
                                <label
                                  htmlFor={`showing-${status}`}
                                  className="text-sm text-gray-700 cursor-pointer flex-1"
                                >
                                  {status}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* External Status Filter */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        External Form Status
                      </label>
                      <div className="relative">
                        <button
                          onClick={() =>
                            setShowExternalStatusDropdown(
                              !showExternalStatusDropdown,
                            )
                          }
                          className="w-full px-3 py-1 border border-gray-300 rounded-md text-sm text-left bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 flex items-center justify-between"
                        >
                          <span className="text-gray-700">
                            {externalStatusFilter.length > 0
                              ? `${externalStatusFilter.length} selected`
                              : "All"}
                          </span>
                          <KeyboardArrowDownIcon className="w-4 h-4 text-gray-400" />
                        </button>
                        {showExternalStatusDropdown && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto">
                            {["Not Started", "Partial", "Completed"].map(
                              (status) => (
                                <div
                                  key={status}
                                  className="flex items-center px-3 py-2 hover:bg-gray-50"
                                >
                                  <input
                                    type="checkbox"
                                    id={`external-${status}`}
                                    checked={externalStatusFilter.includes(
                                      status,
                                    )}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setExternalStatusFilter([
                                          ...externalStatusFilter,
                                          status,
                                        ]);
                                      } else {
                                        setExternalStatusFilter(
                                          externalStatusFilter.filter(
                                            (s) => s !== status,
                                          ),
                                        );
                                      }
                                    }}
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded mr-2"
                                  />
                                  <label
                                    htmlFor={`external-${status}`}
                                    className="text-sm text-gray-700 cursor-pointer flex-1"
                                  >
                                    {status}
                                  </label>
                                </div>
                              ),
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Appfolio Status Filter */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Appfolio Status
                      </label>
                      <div className="relative">
                        <button
                          onClick={() =>
                            setShowAppfolioStatusDropdown(
                              !showAppfolioStatusDropdown,
                            )
                          }
                          className="w-full px-3 py-1 border border-gray-300 rounded-md text-sm text-left bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 flex items-center justify-between"
                        >
                          <span className="text-gray-700">
                            {appfolioStatusFilter.length > 0
                              ? `${appfolioStatusFilter.length} selected`
                              : "All"}
                          </span>
                          <KeyboardArrowDownIcon className="w-4 h-4 text-gray-400" />
                        </button>
                        {showAppfolioStatusDropdown && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto">
                            {["Not Started", "Partial", "Completed"].map(
                              (status) => (
                                <div
                                  key={status}
                                  className="flex items-center px-3 py-2 hover:bg-gray-50"
                                >
                                  <input
                                    type="checkbox"
                                    id={`appfolio-${status}`}
                                    checked={appfolioStatusFilter.includes(
                                      status,
                                    )}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setAppfolioStatusFilter([
                                          ...appfolioStatusFilter,
                                          status,
                                        ]);
                                      } else {
                                        setAppfolioStatusFilter(
                                          appfolioStatusFilter.filter(
                                            (s) => s !== status,
                                          ),
                                        );
                                      }
                                    }}
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded mr-2"
                                  />
                                  <label
                                    htmlFor={`appfolio-${status}`}
                                    className="text-sm text-gray-700 cursor-pointer flex-1"
                                  >
                                    {status}
                                  </label>
                                </div>
                              ),
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Results Summary */}
                  <div className="mt-6 pt-6 border-t border-gray-200">
                    <div className="text-sm text-gray-600">
                      <div className="font-medium">Results Summary</div>
                      <div className="mt-1">
                        Showing{" "}
                        <span className="font-semibold text-gray-900">
                          {filteredMembers.length}
                        </span>{" "}
                        of{" "}
                        <span className="font-semibold text-gray-900">
                          {automaticResponseHistoryList.length}
                        </span>{" "}
                        members
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Main Data Table */}
            <div className="flex-1 bg-white overflow-hidden min-w-0">
              <div className="h-full overflow-x-auto overflow-y-auto">
                <div className="w-full min-w-full">
                  <table className="w-full">
                    <thead className="bg-gray-100 sticky top-0 z-10">
                      <tr className="text-xs md:text-sm">
                        <th className="px-2 md:px-4 py-2 md:py-3 min-w-max">
                          <input
                            type="checkbox"
                            checked={
                              filteredMembers.length > 0 &&
                              filteredMembers.every((member) =>
                                selectedRows.has(
                                  createRowKey(member.email, member.title),
                                ),
                              )
                            }
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              const newSet = new Set(selectedRows);
                              const newTenants: IAutomaticResponseHistory[] =
                                [];

                              filteredMembers.forEach((member) => {
                                const key = createRowKey(
                                  member.email,
                                  member.title,
                                );

                                if (isChecked) {
                                  newSet.add(key);
                                  newTenants.push(member);
                                } else {
                                  newSet.delete(key);
                                }
                              });

                              setSelectedRows(newSet);
                              setSelectedTenants(isChecked ? newTenants : []);
                            }}
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                          />
                        </th>
                        <th className="px-2 md:px-3 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[180px]">
                          Group / Apartment
                        </th>
                        <th className="px-2 md:px-3 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[100px]">
                          Members
                        </th>
                        <th className="px-2 md:px-3 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[160px]">
                          Forms Status
                        </th>
                        <th className="px-2 md:px-3 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[120px]">
                          Mapping
                        </th>
                        <th className="px-2 md:px-3 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[100px]">
                          Payment
                        </th>
                        <th className="px-2 md:px-3 py-2 md:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[100px]">
                          Bidding
                        </th>
                        <th className="px-2 md:px-3 py-2 md:py-3 min-w-[40px]"></th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {isLoading ? (
                        <tr>
                          <td
                            colSpan={8}
                            className="px-2 md:px-4 py-8 md:py-12 text-center"
                          >
                            <Loading />
                          </td>
                        </tr>
                      ) : getPaginatedData().length === 0 ? (
                        <tr>
                          <td
                            colSpan={8}
                            className="px-2 md:px-4 py-8 md:py-12"
                          >
                            <div className="flex flex-col items-center justify-center">
                              <svg
                                className="w-16 h-16 text-gray-300 mb-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={1.5}
                                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                                />
                              </svg>
                              <p className="text-lg font-semibold text-gray-600 mb-1">
                                No Tenant Groups Yet
                              </p>
                              <p className="text-sm text-gray-500 text-center max-w-md">
                                No inquiries have been submitted yet. Tenant
                                groups will appear here once someone inquires
                                and fills out the tenant/guarantor form for an
                                apartment.
                              </p>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        getPaginatedData().map((member) => (
                          <React.Fragment key={member.id}>
                            <tr
                              className={`cursor-pointer transition-colors ${
                                drawerArh?.id === member.id
                                  ? "bg-blue-50/70 border-l-4 border-blue-500"
                                  : "border-l-4 border-transparent hover:bg-gray-50"
                              }`}
                              onMouseEnter={(e) =>
                                handleRowMouseEnter(member, e)
                              }
                              onMouseLeave={handleRowMouseLeave}
                              onClick={() => openGroupDetailsDrawer(member)}
                            >
                              <td
                                className="px-2 md:px-4 py-2 md:py-4 whitespace-nowrap min-w-[40px]"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <input
                                  type="checkbox"
                                  checked={selectedRows.has(
                                    createRowKey(member.email, member.title),
                                  )}
                                  onChange={() => {
                                    const key = createRowKey(
                                      member.email,
                                      member.title,
                                    );
                                    const newSet = new Set(selectedRows);

                                    if (newSet.has(key)) {
                                      newSet.delete(key);
                                      setSelectedTenants((prev) =>
                                        prev.filter(
                                          (t) =>
                                            createRowKey(t.email, t.title) !==
                                            key,
                                        ),
                                      );
                                    } else {
                                      newSet.add(key);
                                      setSelectedTenants((prev) => [
                                        ...prev,
                                        member,
                                      ]);
                                    }
                                    setSelectedRows(newSet);
                                  }}
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                                />
                              </td>

                              {/* Group / Apartment */}
                              <td className="px-2 md:px-3 py-2 md:py-4 whitespace-nowrap text-xs md:text-sm min-w-[180px]">
                                <div className="flex items-center gap-1">
                                  <span className="font-medium text-gray-900">
                                    {member.firstName} {member.lastName}
                                  </span>
                                  {isMandatoryWorkflow(member) && (
                                    <span className="px-1 py-0.5 text-[7px] md:text-[8px] font-bold bg-purple-100 text-purple-700 rounded-full uppercase whitespace-nowrap">
                                      Mandatory Flow
                                    </span>
                                  )}
                                </div>
                                <div
                                  className="max-w-[180px] overflow-hidden text-ellipsis whitespace-nowrap text-xs text-gray-500 mt-0.5"
                                  title={member.title}
                                >
                                  {member.title}
                                  {memberGuarantorInfos[member.id]
                                    ?.numOfBedrooms != null && (
                                    <span>
                                      {" "}
                                      &middot;{" "}
                                      {
                                        memberGuarantorInfos[member.id]
                                          ?.numOfBedrooms
                                      }{" "}
                                      bedroom
                                      {memberGuarantorInfos[member.id]
                                        ?.numOfBedrooms === 1
                                        ? ""
                                        : "s"}
                                    </span>
                                  )}
                                </div>
                              </td>

                              {/* Members — expected count with actual filled count in parentheses */}
                              <td className="px-2 md:px-3 py-2 md:py-4 whitespace-nowrap text-xs md:text-sm text-gray-600 min-w-[100px]">
                                {(() => {
                                  const roster =
                                    memberGuarantorInfos[member.id]
                                      ?.memberAndGaurantorInfo || [];
                                  const filledTenants = roster.filter(
                                    (m) => !m.isGuarantor,
                                  ).length;
                                  const filledGuarantors = roster.filter(
                                    (m) => m.isGuarantor,
                                  ).length;
                                  const expectedTenants = editState[member.id]?.tenants ?? 0;
                                  const expectedGuarantors = editState[member.id]?.guarantors ?? 0;

                                  return (
                                    <div className="space-y-0.5">
                                      <div>
                                        {expectedTenants} Tenant
                                        {expectedTenants === 1 ? "" : "s"}{" "}
                                        <span className="text-gray-400">
                                          ({filledTenants} Filled)
                                        </span>
                                      </div>
                                      <div>
                                        {expectedGuarantors} Guarantor
                                        {expectedGuarantors === 1 ? "" : "s"}{" "}
                                        <span className="text-gray-400">
                                          ({filledGuarantors} Filled)
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })()}
                              </td>

                              {/* Forms Status */}
                              <td className="px-2 md:px-3 py-2 md:py-4 whitespace-nowrap min-w-[160px]">
                                <div className="flex flex-col gap-1">
                                  <div className="flex items-center gap-1">
                                    <span className="text-[10px] text-gray-500">
                                      External:
                                    </span>
                                    <span
                                      className={`inline-flex px-2 py-0.5 text-[10px] font-semibold rounded-full ${
                                        memoizedCalculations[member.id]
                                          ?.externalFormStatus.color ||
                                        "bg-gray-100 text-gray-800"
                                      }`}
                                    >
                                      {memoizedCalculations[member.id]
                                        ?.externalFormStatus.status ||
                                        "Loading..."}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <span className="text-[10px] text-gray-500">
                                      AppFolio:
                                    </span>
                                    <span
                                      className={`inline-flex px-2 py-0.5 text-[10px] font-semibold rounded-full ${
                                        memoizedCalculations[member.id]
                                          ?.appfolioStatus.color ||
                                        "bg-gray-100 text-gray-800"
                                      }`}
                                    >
                                      {memoizedCalculations[member.id]
                                        ?.appfolioStatus.status ||
                                        "Loading..."}
                                    </span>
                                  </div>
                                </div>
                              </td>

                              {/* Mapping */}
                              <td className="px-2 md:px-3 py-2 md:py-4 whitespace-nowrap min-w-[120px]">
                                {(() => {
                                  const info = mappingInfo[member.id];
                                  // mappingTotalMembers accounts for a roster
                                  // bigger than the expected-occupancy default
                                  // (Math.max(totalMembers, providedMembersCount));
                                  // totalMembers alone would undercount it.
                                  const total =
                                    info?.mappingTotalMembers ??
                                    info?.totalMembers ??
                                    0;
                                  const mapped = info?.mappedMembers ?? 0;
                                  const label =
                                    total === 0 || mapped === 0
                                      ? "Not Mapped"
                                      : mapped < total
                                        ? "Partial"
                                        : "Mapped";
                                  const color =
                                    total === 0 || mapped === 0
                                      ? "bg-gray-100 text-gray-800"
                                      : mapped < total
                                        ? "bg-yellow-100 text-yellow-800"
                                        : "bg-green-100 text-green-800";
                                  return (
                                    <div className="flex flex-col gap-1">
                                      <span className="text-xs text-gray-600">
                                        {mapped}/{total}
                                      </span>
                                      <span
                                        className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-semibold rounded-full w-fit ${color}`}
                                      >
                                        {label === "Mapped" && (
                                          <CheckCircle className="!w-3 !h-3" />
                                        )}
                                        {label}
                                      </span>
                                    </div>
                                  );
                                })()}
                              </td>

                              {/* Payment */}
                              <td className="px-2 md:px-3 py-2 md:py-4 whitespace-nowrap text-xs md:text-sm min-w-[100px]">
                                {(() => {
                                  const payment =
                                    editState[member.id]?.payment ||
                                    "not paid";
                                  const label =
                                    payment === "fully paid"
                                      ? "Fully Paid"
                                      : payment === "partial paid"
                                        ? "Partial Paid"
                                        : "Not Paid";
                                  const color =
                                    payment === "fully paid"
                                      ? "bg-green-100 text-green-800"
                                      : payment === "partial paid"
                                        ? "bg-yellow-100 text-yellow-800"
                                        : "bg-gray-100 text-gray-800";
                                  return (
                                    <span
                                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${color}`}
                                    >
                                      {label}
                                    </span>
                                  );
                                })()}
                              </td>

                              {/* Bidding / Eligibility */}
                              <td className="px-2 md:px-3 py-2 md:py-4 whitespace-nowrap text-xs md:text-sm min-w-[100px]">
                                {(() => {
                                  const mapped =
                                    mappingInfo[member.id]?.mappedMembers ?? 0;
                                  const payment =
                                    editState[member.id]?.payment ||
                                    "not paid";
                                  const eligible =
                                    mapped > 0 && payment !== "not paid";
                                  return (
                                    <span
                                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                        eligible
                                          ? "bg-emerald-100 text-emerald-700"
                                          : "bg-gray-100 text-gray-600"
                                      }`}
                                    >
                                      {eligible ? "Eligible" : "Not Eligible"}
                                    </span>
                                  );
                                })()}
                              </td>

                              {/* Open details drawer */}
                              <td
                                className="px-2 md:px-3 py-2 md:py-4 whitespace-nowrap text-center min-w-[40px]"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <button
                                  onClick={() => openGroupDetailsDrawer(member)}
                                  className="text-gray-400 hover:text-blue-600 hover:bg-gray-100 rounded-full p-1 transition-colors"
                                  aria-label="Open group details"
                                >
                                  <KeyboardArrowRightIcon fontSize="small" />
                                </button>
                              </td>
                            </tr>

                            {/* Click-to-expand row disabled in favor of the
                                hover popup below. To revert, remove
                                "false && " from the condition. */}
                            {false && expandedRows[member.id] && (
                              <tr>
                                <td
                                  colSpan={10}
                                  className="px-0 py-0 bg-gray-50"
                                >
                                  <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 px-3 md:px-4 py-4 md:py-6 max-w-full overflow-x-hidden">
                                    {/* 1. SHOWING STATUS */}
                                    <div className="bg-white p-3 md:p-4 rounded-lg border border-gray-200 min-w-0">
                                      <h5 className="font-semibold text-gray-900 mb-3 text-sm md:text-base">
                                        📊 Showing Status & Progress
                                      </h5>
                                      {member.appointmentStatus ===
                                        "MailNotSentYet" ||
                                      member.appointmentStatus === "NoSlots" ? (
                                        <div className="rounded-xl border border-rose-200 bg-gradient-to-r from-rose-50 to-orange-50 px-4 py-3 shadow-sm">
                                          <div className="flex items-start gap-3">
                                            <div className="mt-0.5 inline-flex h-8 w-8 items-center justify-center rounded-full bg-rose-100 text-rose-600">
                                              <svg
                                                className="h-4 w-4"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                                aria-hidden="true"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M18 10A8 8 0 114 3.08V2a1 1 0 10-2 0v4a1 1 0 001 1h4a1 1 0 100-2H5.64A6 6 0 1016 10a1 1 0 102 0zm-7-3a1 1 0 10-2 0v4a1 1 0 001.447.894l2-1a1 1 0 10-.894-1.788l-.553.277V7z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            </div>
                                            <div>
                                              <p className="text-sm font-semibold text-rose-800">
                                                {member.appointmentStatus ===
                                                "NoSlots"
                                                  ? "No slots available"
                                                  : "Appointment Pending"}
                                              </p>
                                              <p className="mt-1 text-sm text-rose-700">
                                                {member.appointmentStatus ===
                                                "NoSlots"
                                                  ? "There are currently no available slots. We will send you an appointment mail as soon as slots become available."
                                                  : "Appointment mail is not sent yet. Showing progress will appear after mail is sent."}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : memberGuarantorInfos[member.id] ? (
                                        <div className="overflow-x-auto min-w-0">
                                          <MemberStatusFlow
                                            arhid={member.id}
                                            info={
                                              memberGuarantorInfos[member.id]
                                            }
                                            mappingInfo={mappingInfo[member.id]}
                                            appointmentStatus={
                                              member.appointmentStatus
                                            }
                                            isMandatory={isMandatoryWorkflow(
                                              member,
                                            )}
                                            getExternalFormStatus={() =>
                                              getExternalFormStatus(member)
                                            }
                                            getAppfolioStatus={() =>
                                              getAppfolioStatus(member)
                                            }
                                          />
                                        </div>
                                      ) : (
                                        <div className="text-xs md:text-sm text-gray-500">
                                          Loading status flow...
                                        </div>
                                      )}
                                    </div>

                                    {/* 2. MAPPING */}
                                    <div className="bg-white p-3 md:p-4 rounded-lg border border-gray-200 min-w-0">
                                      <h5 className="font-semibold text-gray-900 mb-3 text-sm md:text-base">
                                        🔗 Tenant & Guarantor Matching
                                      </h5>

                                      <div className="overflow-x-auto min-w-0">
                                        <TenantMapping
                                          arhid={member.id}
                                          appfolioMembers={appfolioMembers}
                                          memberGuarantorInfo={
                                            memberGuarantorInfos[member.id]
                                          }
                                          onMappingsUpdated={loadMembersData}
                                          prospectiveTenant={{
                                            name: `${member.firstName} ${member.lastName}`,
                                            email: member.email,
                                            phone: member.phone,
                                          }}
                                          calculateMappedMembers={
                                            calculateMappedMembers
                                          }
                                          isNameMatch={isNameMatch}
                                          getStringSimilarity={
                                            getStringSimilarity
                                          }
                                          getEditDistance={getEditDistance}
                                          normalizeName={normalizeName}
                                          tenantEmail={member.email}
                                          tenantName={`${member.firstName} ${member.lastName}`}
                                          apartmentName={member.title}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      )}
                    </tbody>
                  </table>

                  {!isLoading && filteredMembers.length > 0 && (
                    <div className="bg-white px-3 md:px-6 py-3 md:py-4 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3">
                      <div className="flex items-center space-x-2 md:space-x-4">
                        <div className="flex items-center space-x-1 md:space-x-2">
                          <span className="text-xs md:text-sm text-gray-700">
                            <span className="hidden sm:inline">
                              Rows per page:
                            </span>
                            <span className="sm:hidden">Rows:</span>
                          </span>
                          <select
                            value={rowsPerPage}
                            onChange={(e) => {
                              setRowsPerPage(Number(e.target.value));
                              setCurrentPage(1);
                            }}
                            className="border border-gray-300 rounded px-1 md:px-2 py-1 pr-6 md:pr-8 text-xs md:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                          >
                            <option value={2}>2</option>
                            <option value={6}>6</option>
                            <option value={10}>10</option>
                            <option value={15}>15</option>
                            <option value={20}>20</option>
                          </select>
                        </div>
                      </div>

                      <div className="flex items-center space-x-1 md:space-x-2">
                        <button
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1}
                          className={`p-1 md:p-2 rounded-md ${
                            currentPage === 1
                              ? "text-gray-400 cursor-not-allowed"
                              : "text-gray-600 hover:bg-gray-100"
                          }`}
                        >
                          <ChevronLeft className="w-4 h-4 md:w-5 md:h-5" />
                        </button>

                        <span className="text-xs md:text-sm text-gray-700 whitespace-nowrap">
                          <span className="hidden sm:inline">
                            Page {currentPage} of {totalPages}
                          </span>
                          <span className="sm:hidden">
                            {currentPage}/{totalPages}
                          </span>
                        </span>

                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages),
                            )
                          }
                          disabled={currentPage === totalPages}
                          className={`p-1 md:p-2 rounded-md ${
                            currentPage === totalPages
                              ? "text-gray-400 cursor-not-allowed"
                              : "text-gray-600 hover:bg-gray-100"
                          }`}
                        >
                          <ChevronRight className="w-4 h-4 md:w-5 md:h-5" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right-side drawer: Group Progress + Tenant/Guarantor/Venmo Mapping */}
            {drawerArh && (
              <GroupDetailsDrawer
                arh={drawerArh}
                onClose={closeGroupDetailsDrawer}
                appfolioData={appfolioMembers}
                memberGuarantorInfo={memberGuarantorInfos[drawerArh.id]}
                mappingInfo={mappingInfo[drawerArh.id]}
                isMandatory={isMandatoryWorkflow(drawerArh)}
                onMappingsUpdated={loadMembersData}
                getExternalFormStatus={() => getExternalFormStatus(drawerArh)}
                getAppfolioStatus={() => getAppfolioStatus(drawerArh)}
                editState={editState[drawerArh.id]}
                onEditChange={(field, value) => {
                  setEditState((prev) => ({
                    ...prev,
                    [drawerArh.id]: {
                      ...prev[drawerArh.id],
                      [field]: value,
                      changed: true,
                    },
                  }));
                }}
                onSave={() => onSave(drawerArh.id)}
                onOpenInUnsignedList={() => openGroupInUnsignedList(drawerArh)}
                confirmedAppfolioAssignments={confirmedAppfolioAssignments}
              />
            )}
          </>
        )}
      </div>

      {/* Hover popup: shows the Group Details panel when hovering a row */}
      {hoveredMemberId &&
        hoverPopupRect &&
        (() => {
          const hoveredMember = getPaginatedData().find(
            (m) => m.id === hoveredMemberId,
          );
          if (!hoveredMember) return null;

          const popupWidth = Math.min(640, window.innerWidth - 32);
          const left = Math.min(
            Math.max(hoverPopupRect.left, 16),
            window.innerWidth - popupWidth - 16,
          );

          return (
            <div
              className="fixed z-50 bg-gray-50 border border-gray-200 rounded-lg shadow-2xl overflow-y-auto"
              style={{
                top: hoverPopupRect.top + 4,
                left,
                width: popupWidth,
                maxHeight: "75vh",
              }}
              onMouseEnter={handlePopupMouseEnter}
              onMouseLeave={handlePopupMouseLeave}
            >
              {renderGroupDetailsContent(hoveredMember)}
            </div>
          );
        })()}
    </div>
  );
};

export default MembersDetails;
